import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b219f31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-full relative p-4 pb-0" }
const _hoisted_2 = { class: "flex items-center mb-1.5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "h-full w-full"
}
const _hoisted_5 = {
  key: 0,
  class: "flex w-full h-full"
}
const _hoisted_6 = { class: "text-left w-full h-full relative" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "--")
], -1))
const _hoisted_8 = { class: "body body-2 body-alt whitespace-nowrap" }
const _hoisted_9 = {
  key: 0,
  class: "relative"
}
const _hoisted_10 = {
  key: 1,
  class: "body body-2 body-alt block",
  style: {"font-family":"'arial'"}
}
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "body body-1" }
const _hoisted_15 = {
  key: 0,
  class: "ml-3 !font-bold"
}
const _hoisted_16 = {
  key: 1,
  class: "!text-text-alt"
}
const _hoisted_17 = {
  key: 2,
  class: "w-3/5 h-full"
}
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = {
  key: 2,
  class: "h-full w-full flex customHtmlPreview"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-full w-full flex flex-col justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createElementVNode("h3", { class: "skeleton-kpi" })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "body body-2 body-alt skeleton-kpi-title" })
    ])
  ])
], -1))
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightArrowIcon = _resolveComponent("RightArrowIcon")!
  const _component_AnalyticsIcon = _resolveComponent("AnalyticsIcon")!
  const _component_Highcharts = _resolveComponent("Highcharts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["body body-1 w-4/5 !font-bold overflow-hidden whitespace-nowrap max-w-5/6 text-ellipsis", { skeleton: _ctx.loading }])
      }, [
        (_ctx.title && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_RightArrowIcon, { class: "w-6 h-6 ml-6 fill-text-alt stroke-text-alt" })
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!_ctx.error && _ctx.previewType === 'None')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_AnalyticsIcon, { class: "h-20 w-20 absolute top-4 right-0 fill-bg-3" }),
                  _createElementVNode("span", null, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("analytics.noPreview")), 1)
                    ])
                  ])
                ])
              ]))
            : (!_ctx.error && _ctx.previewType !== 'None' && _ctx.previewType !== 'Custom')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["h-full w-full flex", [
          _ctx.graphType === 'PIE' ||
            _ctx.previewInfos.type === 'GAUGE' ||
            _ctx.previewInfos.type === 'SOLID_GAUGE'
            ? 'flex-row'
            : 'flex-col',
          _ctx.previewType === 'ChartAndKPI' || _ctx.previewInfos.type === 'SOLID_GAUGE'
            ? 'justify-between flex-row-reverse'
            : '',
        ]])
                }, [
                  (
            (_ctx.previewType === 'KPI' || _ctx.previewType === 'ChartAndKPI') &&
              !_ctx.loading &&
              _ctx.kpiDetails
          )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(
            _ctx.previewInfos.type === 'GAUGE' ||
              _ctx.previewInfos.type === 'SOLID_GAUGE'
              ? 'w-2/5'
              : _ctx.graphType !== 'PIE' || _ctx.loading
                ? 'w-full'
                : _ctx.graphType === 'PIE' && _ctx.previewType === 'Chart'
                  ? 'w-0'
                  : _ctx.kpiDetails.kpis && _ctx.kpiDetails.kpis.length > 1
                    ? 'w-2/5 flex flex-col justify-center gap-2'
                    : 'w-2/5'
          )
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDetails.kpis, (kpi, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            (
                _ctx.previewInfos.type === 'SOLID_GAUGE' &&
                  _ctx.previewType === 'ChartAndKPI'
              )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createVNode(_component_Highcharts, {
                                    options: 
                  _ctx.kpiToGauge(_ctx.kpiTitle, kpi.value ? kpi.value : 0, kpi.unit, _ctx.previewInfos.type)
                ,
                                    class: "relative"
                                  }, null, 8, ["options"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createElementVNode("div", _hoisted_11, [
                                    (
                    _ctx.graphType === 'PIE' ||
                      ((_ctx.previewInfos.type === 'SOLID_GAUGE' || _ctx.previewInfos.type === 'GAUGE')&&
                        _ctx.previewType === 'KPI')
                  )
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "h-2 w-2 rounded-full mr-1",
                                          style: _normalizeStyle(`background-color: ${_ctx.getKpiColour(
                    kpi.label || _ctx.kpiTitle || _ctx.previewInfos.label
                  )}; min-width: 0.5rem`)
                                        }, null, 4))
                                      : _createCommentVNode("", true),
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(
                    _ctx.graphType === 'PIE' ||
                      ((_ctx.previewInfos.type === 'SOLID_GAUGE' || _ctx.previewInfos.type === 'GAUGE') &&
                        _ctx.previewType === 'KPI')
                      ? 'div'
                      : 'h3'
                  ), {
                                      class: "truncate",
                                      title: kpi.label || _ctx.kpiTitle
                                    }, {
                                      default: _withCtx(() => [
                                        (
                      _ctx.graphType === 'PIE' ||
                        ((_ctx.previewInfos.type === 'SOLID_GAUGE' || _ctx.previewInfos.type === 'GAUGE') &&
                          _ctx.previewType === 'KPI')
                    )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(kpi.label || _ctx.kpiTitle || _ctx.previewInfos.label), 1))
                                          : (_ctx.graphType !== 'PIE')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.formatNumber(+kpi.value)) + " " + _toDisplayString(kpi.unit), 1))
                                            : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["title"]))
                                  ])
                                ])),
                            _createElementVNode("div", _hoisted_14, [
                              (
                  (_ctx.previewInfos.type !== 'SOLID_GAUGE' &&
                    _ctx.graphType === 'PIE') ||
                    ((_ctx.previewInfos.type === 'SOLID_GAUGE' || _ctx.previewInfos.type === 'GAUGE') &&
                      _ctx.previewType === 'KPI')
                )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.formatNumber(+kpi.value)) + " " + _toDisplayString(kpi.unit), 1))
                                : (
                  _ctx.previewInfos.type !== 'SOLID_GAUGE' && _ctx.graphType !== 'PIE'
                )
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(kpi.label || _ctx.kpiTitle), 1))
                                  : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.graphType && !_ctx.loading && !_ctx.error && _ctx.title !== 'Transit')
                    ? (_openBlock(), _createBlock(_component_Highcharts, {
                        key: 1,
                        options: _ctx.chartOptions,
                        class: _normalizeClass([
            _ctx.graphType === 'PIE' && _ctx.previewType !== 'Chart'
              ? 'w-3/5'
              : 'w-[calc(100%+2rem)]  mx-[-1rem] rounded-b-xl'
          , "h-full boorder"])
                      }, null, 8, ["options", "class"]))
                    : _createCommentVNode("", true),
                  (
            _ctx.previewInfos.type === 'GAUGE' ||
              _ctx.previewInfos.type === 'SOLID_GAUGE'
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiDetails.kpis, (kpi, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_Highcharts, {
                                options: 
                  _ctx.kpiToGauge(
                    _ctx.kpiTitle || _ctx.previewInfos.label,
                    kpi.value ? kpi.value : 0,
                    kpi.unit,
                    _ctx.previewInfos.type
                  )
                ,
                                class: "boorder"
                              }, null, 8, ["options"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              : (!_ctx.error && _ctx.previewType !== 'None' && _ctx.previewType === 'Custom')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", { innerHTML: _ctx.previewInfos }, null, 8, _hoisted_20)
                  ]))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
  ]))
}